import React from 'react'
import { Typography } from '@mui/material'
import { formatNumber } from '@auteco/utils/formatsNumber'
import { getEditedCellStyle } from '../styles'

const NumberCell = ({ 
  value, 
  isEdited = false, 
  prefix = '', 
  suffix = '',
}) => (
    <Typography 
      variant="body2"
      sx={getEditedCellStyle(isEdited)}
    >
      {prefix}{formatNumber(value)}{suffix}
    </Typography>
  )

export default NumberCell 